import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

//import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
//import { SmartNavMenu } from "../../components/NavMenu/SmartNavMenu";
import { NavLayout } from "../NavMenu/NavLayout";
import { Title } from "../Title/Title";
//import { shouldPageShowFeedbackBlock } from "../../common/utils/locationUtils";
//import { FeedbackBlock } from "../FeedbackBlock/FeedbackBlock";
//import { ERROR_PAGE_ID } from "../../components/ErrorPages/ErrorPage";

import "./Page.scss";

//TODO this page needs to be refactored

/**
 * Renders page's content, if `isLoading` is false otherwise shows loading indicator.
 *
 * `breadcrumbs`, `title` and `content` can be lazy properties, that is parameterless functions which return actual value.
 * `children` property has priority over `content` property.
 *
 * @typedef {{ name?: string, icon?: string|Object, link?: string}} Breadcrumb
 *
 */
function Page({
  dataTestId = "page",
  title,
  accessories,
  accessoryPosition = "right",
  className,
  children,
  content,
  isLoading = false,
  isPolling = false,
  spinnerColor = "blue",
  navLayoutProps = {},
  feedbackBlock = <></>,
  navMenu,
  id,
}) {
  const mergedPageClasses = classNames("cweb-page", className);
  const containerClassnames = classNames("cweb-page-container");

  if (isLoading) {
    return (
      <div className={mergedPageClasses}>
        <LoadingIndicator asModal={false} />
      </div>
    );
  }

  const maybeTitle = title instanceof Function ? title() : title;

  const accessoryClasses = classNames("cweb-page-header ui:mb-4", {
    [`accessory-${accessoryPosition}`]: true,
  });

  const accessoriesContent =
    accessories instanceof Function ? accessories() : accessories;
  const childrenOrContentProp =
    children || (content instanceof Function ? content() : content);

  return (
    <div id={id} className={containerClassnames}>
      <NavLayout menu={navMenu} {...navLayoutProps}>
        <div className={mergedPageClasses} data-test-id={dataTestId}>
          <div className={accessoryClasses}>
            <Title data-test-id={`${dataTestId}-title`}>{maybeTitle}</Title>
            {isPolling && (
              <LoadingIndicator
                asSpinner={true}
                className="page-spinner"
                spinnerColor={spinnerColor}
              />
            )}
            {accessoriesContent}
          </div>
          {childrenOrContentProp}
        </div>

        {!isLoading && feedbackBlock}
      </NavLayout>
    </div>
  );
}

const breadcrumbItemShape = PropTypes.shape({
  name: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
});

Page.propTypes = {
  breadcrumbs: PropTypes.oneOfType([
    PropTypes.arrayOf(breadcrumbItemShape),
    PropTypes.func,
  ]),
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  spinnerColor: PropTypes.oneOf(["blue", "gray"]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  accessories: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  accessoryPosition: PropTypes.oneOf(["right", "bottom", "left"]),
  content: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.func,
  ]),
  id: PropTypes.string,
  navLayoutProps: PropTypes.object,
};

export default Page;
